import { z } from 'zod';

import { type Judge, judgeSchema } from '@/schemas/judges';
import type { ZodUseMutation, ZodUseQuery } from '@/utils/zodReactQuery';

export const judgesListResponse = z.object({
	items: z.array(judgeSchema),
});
export type JudgesListResponse = z.infer<typeof judgesListResponse>;

export const judgeResponse = judgeSchema;
export type JudgeResponse = z.infer<typeof judgeResponse>;

export type JudgeDraft = Omit<Judge, 'id' | 'createdAt' | 'updatedAt'>;

export const judgesParamsSchema = z
	.object({
		moduleName: z.string().optional(),
	})
	.partial();
export type JudgesParams = z.infer<typeof judgesParamsSchema>;

export type UseJudges = ZodUseQuery<JudgesListResponse, JudgesParams>;
export type UseJudge = ZodUseQuery<JudgeResponse, { id: string }>;
export type UseCreateJudge = ZodUseMutation<JudgeResponse, JudgeDraft>;
export type UseUpdateJudge = ZodUseMutation<JudgeResponse, { id: string; patch: Partial<JudgeDraft> }>;
export type UseDeleteJudge = ZodUseMutation<{ ok: true }, { id: string }>;
export type UseToggleJudge = ZodUseMutation<JudgeResponse, { id: string }>;
